import Swiper from 'swiper';
import { Navigation, Pagination, Parallax, Thumbs } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/parallax';

export default el => {

    const prev = document.querySelector(`.prev[aria-controls="${el.id}"]`);
    const next = document.querySelector(`.next[aria-controls="${el.id}"]`);
    const thumbs = document.querySelector(`.thumbs[aria-controls="${el.id}"]`);
    var paging = el.querySelectorAll(".swiper-pagination");

    if (paging) {
        paging = paging[paging.length - 1];
    }

    const args = {
        slidesPerView: el.dataset.sliderPerView ? el.dataset.sliderPerView : 1.3,
        modules: [Navigation, Pagination, Parallax, Thumbs],
        freeMode: el.dataset.sliderFreeMode !== undefined ? true : false,
        spaceBetween: el.dataset.sliderSpaceBetween ? el.dataset.sliderSpaceBetween : 20,
        autoHeight: el.dataset.sliderAutoHeight !== undefined ? true : false,
        loop: el.dataset.sliderLoop !== undefined ? true : false,
        parallax: true,
        speed: 600,
        grabCursor: true,
        pagination: {
          el: paging,
          clickable: true,
        },
        breakpoints: {
            600: {
                slidesPerView: el.dataset.sliderPerViewMd ? el.dataset.sliderPerViewMd : 1.75,
            },
            1200: {
                slidesPerView: el.dataset.sliderPerViewLg ? el.dataset.sliderPerViewLg : 2.25,
            },
        }
    }

    if (prev && next) {
        args.navigation = {
            nextEl: next,
            prevEl: prev,
        }
    }

    if (thumbs) {
        const thumber = new Swiper(thumbs, {
            modules: [Navigation],
            spaceBetween: 10,
            slidesPerView: 2,
            freeMode: true,
            loop: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: thumbs.querySelector('.next'),
                prevEl: thumbs.querySelector('.prev'),
            },
            breakpoints: {
                321: {
                    slidesPerView: 4
                },
                768: {
                    slidesPerView: 6
                },
                1025: {
                    slidesPerView: 8
                },
                1201: {
                    slidesPerView: 10
                },
            }
        });

        args.thumbs = {
            swiper: thumber,
        }
    }

    const swiper = new Swiper(el, args);
};
